import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Services from "./components/Services";
import Project from "./components/Project";
import Contact from "./components/Contact";
import Services1 from "./components/Services1"
import Services2 from "./components/Services2"
import Services3 from "./components/Services3"
import Services4 from "./components/Services4"
import Project1 from "./components/Project1"
import Project2 from "./components/Project2"
import Blog1 from "./components/Blog1"
import NewsLetterList from "./components/NewsLetterList";
import AdminLogIn from "./components/AdminLogIn";
import Dashboard from "./components/Dashboard";
import WeeklyNewsletter from "./components/WeeklyNewsletter";
import Careers from "./components/Careers";
import JobDescription from "./components/JobDescription";
import Form from "./components/Form";
import ProtectedRoute from "./components/ProtectedRoute";
// import Teams from "./components/Teams";


function App() {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/products" element={<Products />} />
          <Route path="/products/products1" element={<Product1 />} />
          <Route path="/products/products2" element={<Product2 />} />
          <Route path="/products/products3" element={<Product3 />} /> */}
          <Route path="/products" element={<Services />} />
          <Route path="/products/products1" element={<Services1 />} />
          <Route path="/products/products2" element={<Services2 />} />
          <Route path="/products/products3" element={<Services3 />} />
          <Route path="/products/products4" element={<Services4 />} />
          <Route path="/project" element={<Project />} />
          <Route path="/project/project1" element={<Project1 />} />
          <Route path="/project/project2" element={<Project2 />} />
          <Route path="/blog1" element={<Blog1 />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/publication" element={<NewsLetterList />} />
          <Route path="/admin" element={<AdminLogIn />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/weeklynewsletter" element={<WeeklyNewsletter />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/jobdescription" element={<JobDescription />} />
          <Route path="/form" element={<Form />} />
          {/* <Route path="/teams" element={<Teams />} /> */}

          {/* Catch-all route: redirect any unknown path to Home */}
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
